// @flow

export const checks = [
    'isOutbrainDisabled',
    'isUserInContributionsAbTest',
    'isUserNotInContributionsAbTest',
    'hasHighPriorityAdLoaded',
    'hasLowPriorityAdLoaded',
    'hasLowPriorityAdNotLoaded',
    'isOutbrainBlockedByAds',
    'isOutbrainMerchandiseCompliant',
    'isOutbrainMerchandiseCompliantOrBlockedByAds',
];
